<mat-toolbar color="accent">Create Calendar Event</mat-toolbar>

<mat-dialog-content>
  <pr-calendar-event-form
    #calendarEventForm="prCalendarEventForm"
    [calendarEvent]="data.calendarEvent"
    (submitted)="save($event)"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <pt-loader-button
      type="flat"
      color="primary"
      [loading]="calendarEventForm.saving$ | async"
      [disabled]="calendarEventForm.form.invalid"
      (clicked)="calendarEventForm.submit()"
    >
      Create
    </pt-loader-button>
  </pt-buttons-container>
</mat-dialog-actions>
